import { extractErrorMessages } from 'api/utils';
import { AxiosError } from 'axios';
//import fileDownload from 'js-file-download';
import { ExportImportActions } from '.';
import { ImportData, ImportResult } from './Types';

export interface ImportFileResult {
  resultData?: any | undefined;
  resultFileName?: string | undefined;
  importResult: ImportResult;
  errorMessage?: string | undefined;
  NewRecordsImported: number;
  ExistingRecordsUpdated: number;
  ImportErrors: number;
  SystemErrorMessage?: string | null;
}

async function ParseResultBlob(
  data: Blob,
): Promise<{ file: Blob | undefined; obj: any | undefined }> {
  const size = data.size;
  const jsonBlobSize = data.slice(size - 4, size);
  const jsonBlobSizeText = await jsonBlobSize.text();
  const l = parseInt(jsonBlobSizeText);
  const jsonBlob = data.slice(size - l - 4, size - 4);
  const s = await jsonBlob.text();
  const obj = JSON.parse(s);
  return {
    file: size - l - 4 > 0 ? data.slice(0, size - l - 4) : undefined,
    obj: obj,
  };
}
export async function GenericImport(
  file: File | undefined,
  data: ImportData,
): Promise<ImportFileResult | undefined> {
  var res: ImportFileResult | undefined = undefined;
  try {
    if (file !== undefined) {
      const response = await ExportImportActions.Import(
        '/api/GenericImport/Import',
        file,
        data,
      );
      if (response.data !== undefined && response.data.size > 0) {
        const cd = response.headers['content-disposition'];
        const filename =
          cd !== undefined ? cd.split('filename=')[1] : 'ImportResult.xlsx';
        const data = await ParseResultBlob(response.data);
        res = {
          resultData: data.file,
          resultFileName: filename,
          importResult: data.obj.Result as ImportResult,
          NewRecordsImported: data.obj.InsertedRows,
          ExistingRecordsUpdated: data.obj.UpdatedRows,
          ImportErrors: data.obj.Errors,
          SystemErrorMessage: data.obj.SystemErrorMessage,
        };
      } else {
        res = {
          importResult: ImportResult.failed,
          NewRecordsImported: 0,
          ExistingRecordsUpdated: 0,
          ImportErrors: 0,
        };
      }
    } else {
      return Promise.resolve(res);
    }
  } catch (error: unknown) {
    let testmsg = extractErrorMessages(error);
    const message =
      (error as AxiosError)?.response?.data?.error?.innererror?.message ??
      testmsg;
    res = {
      importResult: ImportResult.failed,
      errorMessage: message ?? (error as AxiosError)?.message,
      NewRecordsImported: 0,
      ExistingRecordsUpdated: 0,
      ImportErrors: 0,
    };
  }
  return Promise.resolve(res);
}
